var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.666,
    height: 14.999,
    viewBox: "0 0 16.666 14.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-download-4434865",
    transform: "translate(-100 -149.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_236813",
    "data-name": "Path 236813",
    d: "M354.456,150a.833.833,0,0,0-.833.833v7.985l-1.906-1.906a.833.833,0,1,0-1.178,1.178l3.289,3.289a.833.833,0,0,0,1.215.046c.017-.014.033-.029.049-.045l3.29-3.29a.833.833,0,1,0-1.179-1.178l-1.912,1.912v-7.992a.833.833,0,0,0-.833-.833Z",
    transform: "translate(-246.122)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236814",
    "data-name": "Path 236814",
    d: "M100.833,950a.833.833,0,1,0,0,1.667h15a.833.833,0,1,0,0-1.667Z",
    transform: "translate(0 -786.669)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.51046d88956a67a0e48223ae90d94fb1.svg";
export { ForwardRef as ReactComponent };